import { render, staticRenderFns } from "./editPlatFormAdmin.vue?vue&type=template&id=510128a7&scoped=true&"
import script from "./editPlatFormAdmin.vue?vue&type=script&lang=js&"
export * from "./editPlatFormAdmin.vue?vue&type=script&lang=js&"
import style0 from "./editPlatFormAdmin.vue?vue&type=style&index=0&id=510128a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510128a7",
  null
  
)

export default component.exports